
































import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import { DateHelper } from "../core/helpers/dateHelper";
import { CustomerHelper } from "../crm/helpers/customerHelper";
import { ProgramPackTexts } from "./programPackTexts";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramHero from "../components/programs/ProgramHero.vue";
import ProgramPanel from "../components/programs/ProgramPanel.vue";
import ProgramColumns from "../components/programs/ProgramColumns.vue";
import DateStripPicker from "../components/date/DateStripPicker.vue";
import CzButton from "../components/cz/CzButton.vue";
import CzChoice from "../components/cz/CzChoice.vue";

// Books every pending appointment of a by-days program in progress on the chosen day, as the purchase does.
@Component({
  components: { ProgramPage, ProgramHero, ProgramPanel, ProgramColumns, DateStripPicker, CzButton, CzChoice },
})
export default class MyProgramPackBookPage extends Vue {
  enrollment: any = null;
  loaded: boolean = false;
  texts = ProgramPackTexts;
  today: Date = new Date();
  date: string = "";
  result: any = null;
  start: number = 0;
  searching: boolean = false;
  searchId: number = 0;
  booking: boolean = false;
  errorMsg: string = "";

  get emptyText(): string {
    return this.loaded && this.enrollment === null ? this.$t("This program is not available").toString() : "";
  }

  get itinerary(): any[] {
    const s = this.result && this.result.starts[this.start];
    if (!s) return [];
    const days: any = {};
    s.items.forEach((i: any) => {
      const day = i.start.substring(0, 10);
      (days[day] = days[day] || []).push({ name: i.name, detail: `${this.time(i.start)} - ${this.time(i.end)}` });
    });
    return Object.keys(days).map((d) => ({ name: ProgramPackTexts.date(d, false), when: "", rows: days[d] }));
  }

  // Once an appointment of the first day is booked, the day is set and only the start time is chosen.
  get dayFixed(): boolean {
    const first = this.enrollment.columns[0];
    return !!first && first.cards.some((k: any) => k.cardType === 0 && k.bookings.some((b: any) => !b.cancelled));
  }

  get baseUrl(): string {
    return `${Settings.HostName}/api/publicprogrampacks/customer/${CustomerHelper.getStoredCustomer()}/${this.$route.params.id}`;
  }

  t(key: string): string {
    return this.$t(key).toString();
  }

  time(input: string): string {
    return input.substring(11, 16);
  }

  dateChanged(ev: any) {
    this.date = ev.systemStrDate;
    this.search();
  }

  async search() {
    if (!this.date) return;
    const id = ++this.searchId;
    this.searching = true;
    this.errorMsg = "";
    const data = await new CrudService().httpPost(`${this.baseUrl}/search`, { date: this.date });
    if (id !== this.searchId) return;
    this.result = data && data.ok ? data.model : null;
    this.errorMsg = data && !data.ok && data.errorMsg ? data.errorMsg : "";
    this.start = 0;
    this.searching = false;
  }

  async book() {
    const s = this.result && this.result.starts[this.start];
    if (!s || this.booking) return;
    this.booking = true;
    this.errorMsg = "";
    const res = await new CrudService().httpPost(`${this.baseUrl}/book`, { start: s.start });
    this.booking = false;
    if (!res || !res.ok) {
      this.errorMsg = res && res.errorMsg ? res.errorMsg : this.$t("Crash").toString();
      this.search();
      return;
    }
    this.$router.push(`/customer-programs/${this.$route.params.id}`);
  }

  async mounted() {
    const data = await new CrudService().httpGet(this.baseUrl);
    this.enrollment = data && data.ok && data.model.layout === 0 ? data.model : null;
    this.loaded = true;
    if (this.enrollment) {
      this.dateChanged({ systemStrDate: DateHelper.toSystemString(this.today) });
    }
  }
}
